import {
  Hero,
  Excellence,
  Collections,
  Featured,
  ProductRail,
  VisualBreak,
  ServicePromise,
  CTA,
} from "../sections/HomeSections";
export default function HomePage() {
  return (
    <>
      <Hero />
      <Excellence />
      <Collections />
      <Featured />
      <ProductRail />
      <VisualBreak />
      <ServicePromise />
      <CTA />
    </>
  );
}
